<div class="card-border-radius grey-border p-3 p-xl-4">
  <div class="row action-card-row">
    <div class="col">
      <div
        class="title-row"
        *ngIf="config?.title || config?.iconSrc"
        [style.margin-top.rem]="config?.descriptionText ? 0 : 0.5">
        <img class="icon-size-4" *ngIf="config?.iconSrc" [src]="config.iconSrc" />
        <span *ngIf="config?.title" class="action-card-title">{{ config.title }}</span>
      </div>
      <p class="my-0" *ngIf="config?.descriptionText">{{ config.descriptionText }}</p>
    </div>
    <div class="col-12 col-md-auto">
      <div class="h-100 d-flex flex-column-reverse flex-md-row align-items-center gap-3 ms-auto">
        <lib-button-neutral
          *ngIf="config.secondaryButtonText"
          (buttonClicked)="secondaryButtonClicked.emit()"
          class="d-block w-100"
          i18n>
          <div class="d-flex gap-2 justify-content-center align-items-center">
            {{ config.secondaryButtonText }}
            <img [src]="config?.secondaryButtonIconSrc" />
          </div>
        </lib-button-neutral>
        <lib-button-primary
          [disabled]="config?.primaryButtonDisabled"
          (buttonClicked)="primaryButtonClicked.emit()"
          class="w-100">
          <div class="d-flex gap-2 justify-content-center align-items-center">
            {{ config.primaryButtonText }}
            <img *ngIf="config?.primaryButtonIconSrc" [src]="config.primaryButtonIconSrc" />
          </div>
        </lib-button-primary>
      </div>
    </div>
  </div>
</div>
